import { Assignment } from "./assignment";
import { AssignmentProductMapping } from "./assignment-product-mapping";
import { User } from "./user";

export class Product {
    id!: number;
    created_at!: Date;
    updated_at!: Date;
    created_by_id!: number;
    created_by: User = new User();
    updated_by_id!: number;
    updated_by: User = new User();
    name!: string;
    invoice_export_id!: string;
    show_customers!: boolean;
    show_employees!: boolean;
    require_details!: boolean;
    work_time!: number;
    assignment_id!: number;
    assignment!: Assignment;
    description!: string;
    description_local!: string;
    order_quantity_min!: number;
    order_quantity_max!: number;
    order_quantity_step!: number;
    price!: number;
    discount_quantity!: number;
    discount_amount!: number;
    picture!: string;
    unit!: string;
    assignment_mappings: AssignmentProductMapping[] = []
}